// src/admin/RegisterStudent.jsx
import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase";


const RegisterStudent = ({ fetchStudents }) => {
  const [studentForm, setStudentForm] = useState({
    firstName: "",
    lastName: "",
    address: "",
    email: "",
    phone: "",
    course: "",
    paymentType: "oneTime",   // dropdown selection
    installment: "first",     // default first installment
  });

  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    let fees = "";
    if (studentForm.paymentType === "oneTime") {
      fees = "4500 (One Time)";
    } else {
      fees =
        studentForm.installment === "first"
          ? "3000 (First Installment)"
          : "2000 (Second Installment)";
    }

    await addDoc(collection(db, "students"), {
      ...studentForm,
      fees,
    });

    alert("✅ Student Registered Successfully!");
    setStudentForm({
      firstName: "",
      lastName: "",
      address: "",
      email: "",
      phone: "",
      course: "",
      paymentType: "oneTime",
      installment: "first",
    });

    fetchStudents(); // refresh students list
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Register Student</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* First Name */}
        <input
          type="text"
          placeholder="First Name"
          className="w-full border px-4 py-2 rounded"
          value={studentForm.firstName}
          onChange={(e) => setStudentForm({ ...studentForm, firstName: e.target.value })}
          required
        />

        {/* Last Name */}
        <input
          type="text"
          placeholder="Last Name"
          className="w-full border px-4 py-2 rounded"
          value={studentForm.lastName}
          onChange={(e) => setStudentForm({ ...studentForm, lastName: e.target.value })}
          required
        />

        {/* Address */}
        <input
          type="text"
          placeholder="Address"
          className="w-full border px-4 py-2 rounded"
          value={studentForm.address}
          onChange={(e) => setStudentForm({ ...studentForm, address: e.target.value })}
          required
        />

        {/* Email */}
        <input
          type="email"
          placeholder="Email"
          className="w-full border px-4 py-2 rounded"
          value={studentForm.email}
          onChange={(e) => setStudentForm({ ...studentForm, email: e.target.value })}
          required
        />

        {/* Phone */}
        <input
          type="text"
          placeholder="Phone No."
          className="w-full border px-4 py-2 rounded"
          value={studentForm.phone}
          onChange={(e) => setStudentForm({ ...studentForm, phone: e.target.value })}
          required
        />

        {/* Course Dropdown */}
        <select
          className="w-full border px-4 py-2 rounded"
          value={studentForm.course}
          onChange={(e) => setStudentForm({ ...studentForm, course: e.target.value })}
          required
        >
          <option value="">Select Course</option>
          <option value="Spoken English">Spoken English</option>
          <option value="Personality Development">Personality Development</option>
          <option value="Corporate Training">Corporate Training</option>
          <option value="GDPI">GDPI</option>
          <option value="Teachers Training">Teachers Training</option>
          <option value="Kids Courses">Kids Courses</option>
          <option value="Aptitude Training">Aptitude Training</option>
        </select>

        {/* Payment Type Dropdown */}
        <select
          className="w-full border px-4 py-2 rounded"
          value={studentForm.paymentType}
          onChange={(e) => setStudentForm({ ...studentForm, paymentType: e.target.value })}
        >
          <option value="oneTime">One Time</option>
          <option value="installment">Installment</option>
        </select>

        {/* Installment Radio (only if installment is selected) */}
        {studentForm.paymentType === "installment" && (
          <div className="flex gap-6">
            <label>
              <input
                type="radio"
                name="installment"
                value="first"
                checked={studentForm.installment === "first"}
                onChange={(e) => setStudentForm({ ...studentForm, installment: e.target.value })}
              />
              First Installment (₹3000)
            </label>
            <label>
              <input
                type="radio"
                name="installment"
                value="second"
                checked={studentForm.installment === "second"}
                onChange={(e) => setStudentForm({ ...studentForm, installment: e.target.value })}
              />
              Second Installment (₹2000)
            </label>
          </div>
        )}

        {/* Submit */}
        <button
          type="submit"
          className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
        >
          Register Student
        </button>
      </form>
    </div>
  );
};

export default RegisterStudent;
